<template>
  <UiSwiper>
    <Swiper pagination :modules="[Pagination]" slides-per-view="auto">
      <slot />
    </Swiper>
  </UiSwiper>
</template>

<script setup lang="ts">
import { Pagination } from 'swiper/modules'
import { Swiper } from 'swiper/vue'
import UiSwiper from './UiSwiper.vue'
import 'swiper/css/pagination'
</script>

<style>
.swiper-pagination-bullet {
  @apply bg-button-primary-disabled size-1.5 opacity-100 transition-all;
}

.swiper-pagination-bullet-active {
  @apply bg-button-primary w-5 rounded-3xl;
}
</style>
